import React from 'react';
import { Eyebrow } from './ui/Eyebrow';
import { CtaButton } from './ui/CtaButton';
const trust = ['Natychmiastowy dostęp', 'Dożywotni dostęp', 'Wersja do druku', '30-dniowa gwarancja'];
export function Hero() {
  return <header className="flex w-full items-center justify-center bg-cream lg:min-h-[calc(100vh-3rem)]" data-id="element-68" data-mp="9lbgj25n3de4">
      <div className="mx-auto w-full max-w-3xl px-6 pb-10 pt-10 text-center" data-id="element-69" data-mp="4na0kq3ifu6v">
        <Eyebrow className="text-[11px] tracking-[0.2em]" data-id="element-70" data-mp="128frrovbsnyc">
          System materiałów z plastyki
        </Eyebrow>

        <h1 className="mt-5 font-display text-[38px] font-bold leading-[1.04] tracking-[-0.02em] text-ink sm:text-[50px] lg:text-[56px]" data-id="element-71" data-mp="xaxejma9zmkj">
          Przygotuj cały rok lekcji plastyki w zaledwie{' '}
          <em className="font-display italic text-coral" data-id="element-72" data-mp="nbomx02vuk1c">5 minut</em>
        </h1>

        <p className="mx-auto mt-4 max-w-md text-[14px] leading-relaxed text-muted" data-id="element-73" data-mp="3d2ldtocrhr6i">
          10 tomów gotowych materiałów — od klasy 4 po maturę. Koniec z
          improwizacją i szukaniem pomysłów w niedzielny wieczór.
        </p>

        <div className="mt-7" data-id="element-74" data-mp="3j6fvvj9ob1ao">
          <img src="https://cdn.magicpatterns.com/uploads/o6YS5JHZEFscRqs1rQKAU1/Captura_de_pantalla_2026-09-10_a_la(s)_9.22.24_a._m..png" alt="Pakiet PLASTYKA GOTOWA — 10 tomów materiałów, karty pracy i prezentacje na komputerze, tablecie i telefonie" className="mx-auto w-full max-w-[34rem] object-contain lg:max-h-[42vh]" width={1560} height={980} data-id="element-75" data-mp="3o7c4ga4yzbmf" />
        </div>

        <div className="mt-7" data-id="element-76" data-mp="359j9bu0l85zl">
          <CtaButton label="CHCĘ PAKIET PLASTYKA GOTOWA™" className="px-11 py-4 text-[13px]" data-id="element-77" data-mp="35aklk1tcayiw" />
        </div>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[13px] text-muted/80" data-id="element-78" data-mp="2vi5558xoyi04">
          {trust.map((item, index) => <li key={item} className="flex items-center gap-4" data-id="element-79" data-mp="2hlj8g19kaz7a" data-mpi={index}>
              {index > 0 && <span className="text-muted/50" aria-hidden="true" data-id="element-80" data-mp="2lmla0oqybncf">
                  ·
                </span>}
              {item}
            </li>)}
        </ul>
      </div>
    </header>;
}